"use client";

import { createInstance } from "i18next";
import { I18nextProvider } from "react-i18next";

import initTranslations from "@@/app/i18n";

interface ITranslationsProviderProps {
	children: any
	locale: any
	namespaces: any
	resources: any
}

export default function TranslationsProvider(props: ITranslationsProviderProps) {
	const i18n = createInstance();

	initTranslations(props.locale, props.namespaces, i18n, props.resources);

	return <I18nextProvider i18n={i18n}>{props.children}</I18nextProvider>;
}
